import React, { Component } from "react";
import axios from "../../util/axios";
import moment from "moment";
import { trackPromise } from "react-promise-tracker";

import DateRangeCalendar from "../../components/DateRangeCalendar";
import CobrandSelector from "../../components/cobrandselection/CobrandSelector";

class Reports extends Component {
  state = {
    reports: [],
    cobrandId: this.props.match
      ? this.props.match.params.cobrandId
      : JSON.parse(localStorage.getItem("userData")).cobrands[0].id,
    selectedDuration: "",
    selectedDurationId: 0,
    selectedReport: "",
    jobStatus: "init",
    reportId: "",
    options: [
      { value: "", label: "Select" },
      { value: "cm", label: "Current Month" },
      { value: "lm", label: "Last Month" },
      { value: "cq", label: "Current Quarter" },
      { value: "lq", label: "Last Quarter" },
      { value: "cs", label: "Custom Range" }
    ],
    customEnabled: false,
    datesSelected: false
  };

  componentDidMount() {
    trackPromise(
      axios
        .get("/api/report/config?id=" + this.state.cobrandId, {
          headers: {
            Authorization: JSON.parse(localStorage.getItem("userData")).token,
            "Cobrand-Id": this.state.cobrandId
          }
        })
        .then(response => {
          const reports = response.data[0];
          const reportConfig = reports.reportConfigs;
          const reorderedConfig = [];

          reportConfig.forEach(element => {
            if (element.id == 103) {
              reorderedConfig[0] = element;
            }
            if (element.id == 101) {
              reorderedConfig[1] = element;
            }
            if (element.id == 104) {
              reorderedConfig[2] = element;
            }
            if (element.id == 102) {
              reorderedConfig[3] = element;
            }
          });
          this.setState({ reports: reorderedConfig });
        })
        .catch(err => {
          console.log(err);
        })
    );
  }

  handleDuration = event => {
    this.setState({
      selectedDuration: event.target.value,
      selectedDurationId: event.target.id,
      customEnabled: event.target.value === "cs" ? true : false
    });
  };

  handleSelect = event => {
    this.resetDuration();
    this.resetGenerateButton();
    this.setState({ selectedReport: event.target.value });
  };

  generateReport = async () => {
    const reportType = this.state.selectedReport;
    const now = moment().format("YYYY-MM-DD");
    var fromDate = "";
    var toDate = "";

    if (this.state.selectedDuration === "cm") {
      fromDate = moment()
        .startOf("month")
        .format("YYYY-MM-DD");
      toDate = now;
    }
    if (this.state.selectedDuration === "lm") {
      fromDate = moment()
        .subtract(1, "months")
        .startOf("month")
        .format("YYYY-MM-DD");
      toDate = moment(now)
        .subtract(1, "months")
        .endOf("month")
        .format("YYYY-MM-DD");
    }
    if (this.state.selectedDuration === "cq") {
      fromDate = moment()
        .startOf("quarter")
        .format("YYYY-MM-DD");
      toDate = moment()
        .endOf("quarter")
        .format("YYYY-MM-DD");
    }
    if (this.state.selectedDuration === "lq") {
      fromDate = moment()
        .subtract(1, "quarter")
        .startOf("quarter")
        .format("YYYY-MM-DD");
      toDate = moment()
        .subtract(1, "quarter")
        .endOf("quarter")
        .format("YYYY-MM-DD");
    }
    if (this.state.selectedDuration === "cs") {
      fromDate = this.state.filterCriteria["fromDate"];
      toDate = this.state.filterCriteria["toDate"];
    }

    const data = {};
    data.reportId = reportType;
    data.cobrandIds = this.state.cobrandId;
    //convert the dates to UTC before sending to server.
    var fromDateToconvert = moment(fromDate)
      .startOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    var toDateToconvert = moment(toDate)
      .endOf("day")
      .format("YYYY-MM-DD HH:mm:ss");

    console.log("From Date Before UTC: " + fromDateToconvert);
    console.log("To Date Before UTC: " + toDateToconvert);

    data.from = moment.utc(moment(fromDateToconvert)).format();
    data.to = moment.utc(moment(toDateToconvert)).format();

    console.log("From Date After UTC: " + data.from);
    console.log("To Date After UTC: " + data.to);

    const response = await axios.post("/api/report/job", data, {
      headers: {
        Authorization: JSON.parse(localStorage.getItem("userData")).token,
        "Cobrand-Id": this.state.cobrandId
      }
    });

    let duration = {
      cm: "Current Month",
      lm: "Last Month",
      cq: "Current Quarter",
      lq: "Last Quarter",
      cs: "Custom Range"
    };

    if (response.data.id != "" || response.data.id != "undefined") {
      this.props.history.push("/reportJob/" + response.data.id);
      localStorage.setItem(
        "selectedDuration",
        duration[this.state.selectedDuration]
      );
      localStorage.setItem("reportProps", "");
      localStorage.setItem("printProps", "");
    } else {
      this.props.history.push("/reports");
    }
  };

  selectedDates = dates => {
    if (dates === null) {
      this.setState({ datesSelected: false });
      //this.setState({ errorDurationMessage: false });
      let defaultFromDate = moment()
        .subtract(6, "d")
        .format("YYYY-MM-DD");
      let defaultToDate = moment().format("YYYY-MM-DD");
      const filterCriteria = { ...this.state.filterCriteria };
      filterCriteria["fromDate"] = defaultFromDate;
      filterCriteria["toDate"] = defaultToDate;
      this.setState({ filterCriteria });
      return;
    }
    this.setState({ datesSelected: true });
    let newFromDate = moment(dates[0]).format("YYYY-MM-DD");
    let newToDate = moment(dates[1]).format("YYYY-MM-DD");
    const filterCriteria = { ...this.state.filterCriteria };
    filterCriteria["fromDate"] = newFromDate;
    filterCriteria["toDate"] = newToDate;
    this.setState({ filterCriteria });
  };

  //resetFilterCriteria = () => {
  //let filterCriteria = { ...this.state.filterCriteria };
  //filterCriteria["fromDate"] = "";
  //filterCriteria["toDate"] = "";

  //this.setState({ filterCriteria, datesSelected: false });
  //this.refs.drc.resetDates();
  //this.props.filter();
  //};

  ///
  isGenerateDisabled = () => {
    if (this.state.selectedDuration === "cs") {
      return !(
        this.state.selectedReport === this.state.selectedDurationId &&
        this.state.datesSelected
      );
    } else {
      return !(
        this.state.selectedReport === this.state.selectedDurationId &&
        this.state.selectedDuration !== ""
      );
    }
  };

  resetDuration = () => {
    if (this.state.selectedReport !== "" && !this.state.customEnabled) {
      document.getElementById(
        this.state.selectedReport.toString()
      ).selectedIndex = 0;
    }
  };

  resetGenerateButton = () => {
    this.setState({
      customEnabled: false,
      datesSelected: false,
      selectedDuration: "",
      selectedDurationId: 0
    });
  };
  ///

  render() {
    const generateDisabled = this.isGenerateDisabled();
    const { reports } = this.state;
    return (
      <React.Fragment>
        <div className="container main" id="reports-landing">
          <div className="row mt-4 mb-2">
            <div className="col-md-4 ml-auto">
              <CobrandSelector />
            </div>
          </div>

          <div class="heading mt-2 mb-4">Select Report</div>

          <div class="rdt_Table">
            <div class="rdt_TableHead">
              <div class="rdt_TableHeadRow">
                <div className="row">
                  <div className="col-1"></div>
                  <div className="col-3 rdt_TableCol customTableHeader">
                    <b>REPORT NAME</b>
                  </div>
                  <div className="col-5 rdt_TableCol customTableHeader">
                    <b>DESCRIPTION</b>
                  </div>
                  <div
                    className="col-3 rdt_TableCol customTableHeader"
                    style={{ textAlign: "center" }}
                  >
                    <b>DURATION</b>
                  </div>
                </div>
              </div>
            </div>
            <div class="rdt_TableBody">
              {reports.map((item, index) => (
                <div class="rdt_TableRow customTableRow">
                  <div
                    class="rdt_TableCell"
                    style={{
                      paddingLeft: "20px",
                      display: "flex",
                      alignItems: "center",
                      width: "3%"
                    }}
                  >
                    <div class="react-data-table--cell-content">
                      <input
                        key={item.id}
                        type="radio"
                        value={item.id}
                        name="rowname"
                        onChange={this.handleSelect.bind(this)}
                      />
                    </div>
                  </div>
                  <div
                    class="rdt_TableCell customTableCell "
                    style={{ width: "25%" }}
                  >
                    <div class="react-data-table--cell-content">
                      {item.name}
                    </div>
                  </div>
                  <div
                    class="rdt_TableCell customTableCell"
                    style={{ width: "44%" }}
                  >
                    <div class="react-data-table--cell-content">
                      {item.description}
                    </div>
                  </div>
                  {(!this.state.customEnabled ||
                    this.state.selectedReport.toString() !==
                      item.id.toString()) && (
                    <div class="rdt_TableCell" style={{ width: "26%" }}>
                      <div
                        class="react-data-table--cell-content"
                        style={{ padding: 10 }}
                      >
                        <select
                          id={item.id}
                          className="custom-select"
                          onChange={this.handleDuration.bind(this)}
                          disabled={
                            this.state.selectedReport.toString() !==
                            item.id.toString()
                          }
                        >
                          {this.state.options.map((option, index) => (
                            <option key={index} value={option.value}>
                              {option.label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  )}
                  {this.state.customEnabled &&
                    this.state.selectedReport.toString() ===
                      item.id.toString() && (
                      <div
                        class="rdt_TableCell customTableCell"
                        style={{ width: "26%", paddingLeft: 9 }}
                      >
                        <div class="react-data-table--cell-content">
                          <div className="col-3 custom-duration">
                            <DateRangeCalendar
                              onSelectedDates={this.selectedDates}
                              maxDate={new Date()}
                              ref="drc"
                            />
                            <i
                              class="fas fa-lg fa-angle-down custom-arrow"
                              onClick={this.resetGenerateButton}
                            ></i>
                          </div>
                        </div>
                      </div>
                    )}
                </div>
              ))}
            </div>
          </div>
          <br />
          <button
            type="button"
            className="btn btn-primary"
            style={{ float: "right" }}
            onClick={this.generateReport}
            disabled={generateDisabled}
          >
            Generate Report
          </button>
        </div>
      </React.Fragment>
    );
  }
}

export default Reports;
